module.exports = __webpack_public_path__ + "img/dl (13).76892794.jpg";